import React, {Fragment, useEffect} from "react";
import {BrowserRouter as Router, Route, Routes, Navigate, useLocation} from "react-router-dom";
import AdminRoute from "../shared/components/AdminRoute";
import MemberRoute from "../shared/components/MemberRoute";
import WindowHeader from "../shared/components/WindowHeader";
import Footer from "../shared/components/Footer";
import AuthProvider from "../components/auth/AuthenticationHandler";
import "../styles/js/plugins/fontawesome/all.js";  // Import FontAwesome JS
import "../styles/css/all.css"; 

import {ToastContainer} from "react-toastify";

// page imports
import SuperAdminManagementPage from "../pages/SuperAdminManagementPage";
import AdminLogin from "../pages/AdminLoginPage";
import PublicLogin from "../pages/PublicLoginPage";
import PageWrapper from "../shared/components/PageWrapper";
import NotFoundPage from "../pages/NotFoundPage";
import AdminSettingsPage from "../pages/AdminSettingsPage";
import SetPasswordPage from "../pages/SetPasswordPage";
import NewYearSetupPage from "../pages/NewYearSetupPage";
import YearlySettingDetailsPage from "../pages/YearlySettingDetailsPage";
import CustomerManagementPage from "../pages/CustomerManagementPage";
import CustomerDetailsPage from "../pages/CustomerDetailsPage";
import JobDetailsPage from "../pages/JobDetailsPage";
import EstimateRequestPage from "../pages/EstimateRequestPage";
import EstimateRequestThanksPage from "../pages/EstimateRequestThanksPage";
import EstimateListPage from "../pages/EstimateListPage";
import EstimateDetailsPage from "../pages/EstimateDetailsPage";
import EstimateSchedulingPage from "../pages/EstimateSchedulingPage";
import {DndProvider} from "react-dnd";
import {HTML5Backend} from "react-dnd-html5-backend";
import ReportsPage from "../pages/ReportsPage";
import ScheduledJobsPage from "../pages/ScheduledJobsPage";
import WebNotRunPage from "../pages/WebNotRunPage";
import NoEstimateRequestAvailablePage from "../pages/NoEstimateRequestAvailablePage";
import EstimateScheduleThanksPage from "../pages/EstimateScheduleThanksPage";
import {PageProvider} from "../shared/components/PageContext";
import DepositSlipsPage from "../pages/DepositSlipsPage";
import TruckBillingPage from "../pages/TruckBillingPage";
import EstimateReschedulingPage from "../pages/EstimateReschedulingPage";
import MakePaymentPage from "../pages/MakePaymentPage";
import PaymentThanksPage from "../pages/PaymentThanksPage";
import {LoadingProvider} from "../shared/components/LoadingContext";


const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
};
const App: React.FC = () => {
  return (
      <>
          <LoadingProvider>
              <DndProvider backend={HTML5Backend}>
                  <PageProvider>
                      <Router>
                          <ScrollToTop/>
                          <AuthProvider>
                              <WindowHeader/>
                              <Routes>
                                  {/* Public Routes */}
                                  <Route path="/" element={<Navigate to="/login" />} />
                                  <Route path="/login" element={<PublicLogin />} />
                                  <Route path="/no-request-ready" element={<NoEstimateRequestAvailablePage />} />
                                  <Route path="/admin-login" element={<AdminLogin />} />
                                  <Route path="/set-password/:userId/:token" element={<SetPasswordPage />} />
                                  <Route path="/make-payment" element={<MakePaymentPage/>} />
                                  <Route path="/make-payment/thanks" element={<PaymentThanksPage/>} />
                                  <Route path="/request-estimate" element={<EstimateRequestPage/>} />
                                  <Route path="/request-estimate/thanks" element={<EstimateRequestThanksPage/>} />
    
                                  {/* Member Routes */}
                                  <Route element={<MemberRoute />}>
                                      <Route path="/member" element={<PageWrapper isAdmin={false}/>}>
                                          <Route path="schedule-estimate" element={<EstimateSchedulingPage />} />
                                          <Route path="reschedule-estimate" element={<EstimateReschedulingPage />} />
                                          <Route path="schedule-estimate/thanks" element={<EstimateScheduleThanksPage/>} />
                                          {/*<Route path="users" element={<UserManagementPage />} />*/}
                                      </Route>
                                  </Route>
    
                                  {/* Admin Routes */}
                                  <Route element={<AdminRoute />}>
                                      <Route path="/admin" element={<PageWrapper isAdmin={true}/>}>
                                          <Route path="management" element={<SuperAdminManagementPage />} />
                                          <Route path="reports" element={<ReportsPage />} />
                                          <Route path="customers" element={<CustomerManagementPage />} />
                                          <Route path="customer-details" element={<CustomerDetailsPage />} />
                                          <Route path="job-details" element={<JobDetailsPage />} />
                                          <Route path="admin-settings" element={<AdminSettingsPage />} />
                                          <Route path="yearly-settings" element={<NewYearSetupPage />} />
                                          <Route path="yearly-settings/details/:year" element={<YearlySettingDetailsPage />} />
                                          <Route path="estimates" element={<EstimateListPage />} />
                                          <Route path="estimate-details" element={<EstimateDetailsPage />} />
                                          <Route path="web-not-run" element={<WebNotRunPage />} />
                                          <Route path="scheduled-jobs" element={<ScheduledJobsPage />} />
                                          <Route path="deposit-slips" element={<DepositSlipsPage />} />
                                          <Route path="truck-billing" element={<TruckBillingPage />} />
                                      </Route>
                                  </Route>
    
                                  {/* 404 page) */}
                                  <Route path="*" element={<NotFoundPage />} />
                              </Routes>
                              <Footer/>
                          </AuthProvider>
                      </Router>
                  </PageProvider>
                  <ToastContainer/>
              </DndProvider>
          </LoadingProvider>
      </>
  );
};

export default App;
